import ButtonAction from './ButtonAction';

ButtonAction.install = function(Vue) {
  Vue.component(ButtonAction.name, ButtonAction);
};

export default ButtonAction;
